<template>
  <div id="app" :class="[{ 'pt': !isHome }]">
    <Header :is-home="isHome"/>
    <router-view/>
    <Footer/>
  </div>
</template>

<script>
import Header from '@/components/header';
import Footer from '@/components/footer';

export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      isHome: this.$route.name === 'Home',
      channelIds: []
    }
  },
    mounted() {
        this.channelIds = this.$initChannelsIds();
        console.log("this.channelIds",this.channelIds)
    },
  watch: {
    $route(to) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.isHome = to.name === 'Home';
    }
  }
}
</script>

<style>
#app {
  width: 100vw;
  min-height: 100vh;
}
a{
  text-decoration: none;
}
.pt {
  padding-top: 112px;
}
</style>
